import { render, staticRenderFns } from "./DialogOtpClients.vue?vue&type=template&id=f28e86b2&"
import script from "./DialogOtpClients.vue?vue&type=script&lang=js&"
export * from "./DialogOtpClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports